import tablePrice from '@/views/private/realestate/pricetablemanagement/components/tablePrice/tablePrice.vue'
import formPrice from '@/views/private/realestate/pricetablemanagement/components/formPrice/formPrice.vue'
import detailsPrice from './components/detailsPrice/detailsPrice.vue'
import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import PermissionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'

export default {
  name: 'PriceTableManagement',
  mixins: [ PermissionMixin ],
  components: {
    tablePrice,
    formPrice,
    detailsPrice
  },
  data () {
    return {
      flDetails: false,
      selectedEnterprise: {},
      roles: Roles
    }
  },
  methods: {
    edit (obj) {
      this.selectedEnterprise = obj
      this.flDetails = true
    },
    deleteEnterprise (id) {
      EnterpriseRepository.DeleteEnterprise(id)
        .then(Response => {
          this.consultaenterprise = Response.data.data
          this.$refs.tableGridEnterprise.Delete(Response)
        })
        .catch(() => {})
    },
    GetFilter (dataSearch) {
      this.$refs.tablePrice.dataFilter = dataSearch
      this.$refs.tablePrice.getFilter()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/pricetablemanagement/pricetablemanagement.js